import { useSearchParams } from 'react-router-dom'
import { Form, Formik } from 'formik'

import { OwnerTransferVerifyForm } from './owner-transfer-verify-modal.component'
import { useVerifyOwnerTransfer } from 'src/hooks'

import { changePasswordVerificationSchema } from 'src/common/validations'

interface IOwnerTransferFormWrapperProps {
  onClose: () => void
}

const OwnerTransferVerifyFormWrapper = ({ onClose }: IOwnerTransferFormWrapperProps) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { mutateAsync: verifyOwnerTransfer } = useVerifyOwnerTransfer()

  const handleVerificationSubmit = async ({ code }: { code: string }) => {
    const data = await verifyOwnerTransfer(code)
    if (!data) return
    searchParams.delete('transfer_code')
    setSearchParams(searchParams)
    onClose()
  }

  return (
    <Formik
      validationSchema={changePasswordVerificationSchema}
      initialValues={{ code: searchParams.get('transfer_code') || '' }}
      onSubmit={handleVerificationSubmit}
    >
      <Form>
        <OwnerTransferVerifyForm />
      </Form>
    </Formik>
  )
}

export { OwnerTransferVerifyFormWrapper }
